import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32f3fad3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wechatContacts" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "联系人", -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "聊天记录", -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "群聊", -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "searchConvDialog" }
const _hoisted_16 = { class: "searchConvDialog" }

import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { ref, computed, watch } from "vue";
import { TgActions, TgGetters, TgMutations } from "@/store/modules/telegram";
import TgSessionCard from "@/components/telegram/TgSessionCard.vue";
import TgMsgWindow from "@/components/telegram/TgMsgWindow.vue";



import { defineComponent } from "vue";

const __default__ = defineComponent({
    name: "TgSearchWindow"
})



export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const activeName = ref<string>('contact')
const searchDialogForConv = ref<boolean>(false)
const searchDialogForChatRoom = ref<boolean>(false)
const selectUser = ref<number>(0)

const route = useRoute();
const store = useStore();
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const tgIdCom = computed(() => {
    return store.getters[`telegram/${TgGetters.getMeId}`];
});

const searchType = computed(() => {
    return store.getters[`telegram/${TgGetters.getSearchType}`];
});


const searchTarget = computed(() => {
    return store.getters[`telegram/${TgGetters.getSearchTarget}`];
});
const searchContactList = computed(() => {
    return store.getters[`telegram/${TgGetters.getSearchContactList}`];
});
const searchContactLoding = computed(() => {
    return store.getters[`telegram/${TgGetters.getIsSearchContactLoading}`];
});
const searchContactLoaded = computed(() => {
    return store.getters[`telegram/${TgGetters.getIsSearchContactAllLoaded}`];
});


const searchConvList = computed(() => {
    return store.getters[`telegram/${TgGetters.getSearchConvList}`];
});
const searchConvLoding = computed(() => {
    return store.getters[`telegram/${TgGetters.getIsSearchConvLoading}`];
});
const searchConvLoaded = computed(() => {
    return store.getters[`telegram/${TgGetters.getIsSearchConvAllLoaded}`];
});

const ChatList = computed(() => {
    return store.getters[`telegram/${TgGetters.getSearchChatList}`];
});
const searchChatLoding = computed(() => {
    return store.getters[`telegram/${TgGetters.getIsSearchChatLoading}`];
});
const searchChatLoaded = computed(() => {
    return store.getters[`telegram/${TgGetters.getIsSearchChatAllLoaded}`];
});

const selectedConv = computed(() => {
    return store.getters[`telegram/${TgGetters.getSelectedConv}`];
});

watch(searchType, (newValue: string, oldValue: string) => {
    activeName.value = searchType.value === '用户' ? 'chat' : searchContactList.value.length === 0 ? 'conv' : 'contact'
});
watch(searchContactList, (newValue: string, oldValue: string) => {
    activeName.value = searchType.value === '用户' ? 'chat' : searchContactList.value.length === 0 ? 'conv' : 'contact'
});


const handleClick = (contact: any, type: string) => {
    store.commit(`telegram/${TgMutations.setSelectedConv}`, contact);
    store.commit(`telegram/${TgMutations.setSelectedConvType}`, type);
    if (type === 'searchConv') {
        searchDialogForConv.value = true
    } else if (type === 'searchChat') {
        selectUser.value = contact.Participants.Id
        searchDialogForChatRoom.value = true
        store.commit(`telegram/${TgMutations.setSearchMsgListByConvId}`, { convId: contact.ConversationID, msgList: [], isAppend: false });
        store.commit(`telegram/${TgMutations.setSearchMsgAllLoadedByConvId}`, { convId: contact.ConversationID, isAllLoaded: false });
    }
}

const isConvSelected = (convId: number) => {
    if (selectedConv.value) {
        return selectedConv.value.ConversationID === convId;
    } else {
        return false
    }
}
const isSearchChatSelected = (convId: number, userId: number) => {
    if (selectedConv.value) {
        return selectedConv.value.ConversationID === convId && selectUser.value === userId;
    } else {
        return false
    }
}

const loadTgSearch = () => {
    let projId = projectId.value;
    let uid = targetId.value
    let target = searchTarget.value
    let tgId = tgIdCom.value

    if (activeName.value === 'contact' && !searchContactLoaded.value && !searchContactLoding.value) {
        store.dispatch(`telegram/${TgActions.asyncGetSearchingContactByUidAndTgId}`, { projId: projId, uid: uid, tgId: tgId, isAppend: true, target: target });
    } else if (activeName.value === 'conv' && !searchConvLoaded.value && !searchConvLoding.value) {
        store.dispatch(`telegram/${TgActions.asyncGetSearchingConvByUidAndTgId}`, { projId: projId, uid: uid, tgId: tgId, isAppend: true, target: target });
    } else if (activeName.value === 'chat' && !searchChatLoaded.value && !searchChatLoding.value) {
        store.dispatch(`telegram/${TgActions.asyncGetSearchingChatByUidAndTgId}`, { projId: projId, uid: uid, tgId: tgId, isAppend: true, target: target });
    }
}




return (_ctx: any,_cache: any) => {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, {
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
      accordion: ""
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(searchType) !== '用户' && _unref(searchContactList).length !== 0)
            ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                key: 0,
                name: "contact"
              }, {
                title: _withCtx(() => [
                  _hoisted_2
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchContactList), (contact) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: contact.ConversationID
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass({ 'tgConv': true, 'tgConvActive': isConvSelected(contact.ConversationID) }),
                        onClick: ($event: any) => (handleClick(contact, 'searchContact'))
                      }, [
                        _createElementVNode("div", null, [
                          _createVNode(TgSessionCard, {
                            msgSender: contact.Title === '' ? contact.Name : contact.Title,
                            msgContent: contact.Name,
                            target: _unref(searchTarget)
                          }, null, 8, ["msgSender", "msgContent", "target"])
                        ])
                      ], 10, _hoisted_3)
                    ]))
                  }), 128)),
                  (_unref(searchContactLoding))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, "加载中......"))
                    : _createCommentVNode("", true),
                  (_unref(searchContactLoaded))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, "------已加载全部-------"))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(searchType) !== '用户' && _unref(searchConvList).length !== 0)
            ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                key: 1,
                name: "conv"
              }, {
                title: _withCtx(() => [
                  _hoisted_6
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchConvList), (conv) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: conv.ConversationID
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass({ 'tgConv': true, 'tgConvActive': isConvSelected(conv.ConversationID) }),
                        onClick: ($event: any) => (handleClick(conv, 'searchConv'))
                      }, [
                        _createElementVNode("div", null, [
                          _createVNode(TgSessionCard, {
                            msgSender: conv.DisplayTitle === '' ? conv.Title : conv.DisplayTitle,
                            msgContent: conv.count + '条相关聊天记录',
                            target: ''
                          }, null, 8, ["msgSender", "msgContent"])
                        ])
                      ], 10, _hoisted_7)
                    ]))
                  }), 128)),
                  (_unref(searchConvLoding))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, "加载中......"))
                    : _createCommentVNode("", true),
                  (_unref(searchConvLoaded))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, "------已加载全部-------"))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(searchType) === '用户' && _unref(ChatList).length !== 0)
            ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                key: 2,
                name: "chat"
              }, {
                title: _withCtx(() => [
                  _hoisted_10
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ChatList), (chat) => {
                    return (_openBlock(), _createElementBlock("div", { key: chat }, [
                      _createElementVNode("div", {
                        class: _normalizeClass({ 'tgConv': true, 'tgConvActive': isSearchChatSelected(chat.Chat.ConversationID, chat.Chat.Participants.Id) }),
                        onClick: ($event: any) => (handleClick(chat.Chat, 'searchChat'))
                      }, [
                        _createElementVNode("div", null, [
                          _createVNode(TgSessionCard, {
                            msgSender: chat.Chat.Title,
                            msgContent: '包含用户：' + chat.Chat.Participants.Name + (chat.Chat.Participants.Username === '' ? '' : '(' + chat.Chat.Participants.Username + ')') + '\n ID：' + chat.Chat.Participants.Id,
                            target: _unref(searchTarget)
                          }, null, 8, ["msgSender", "msgContent", "target"])
                        ])
                      ], 10, _hoisted_11)
                    ]))
                  }), 128)),
                  (_unref(searchChatLoding))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, "加载中......"))
                    : _createCommentVNode("", true),
                  (_unref(searchChatLoaded))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, "------已加载全部-------"))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(searchContactList).length === 0 && _unref(searchConvList).length === 0 && _unref(ChatList).length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, "搜索结果为空"))
            : _createCommentVNode("", true)
        ])), [
          [_directive_infinite_scroll, loadTgSearch]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (searchDialogForConv.value)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          ref: "SearchDialogForConv",
          modelValue: searchDialogForConv.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchDialogForConv).value = $event)),
          title: "查找聊天记录",
          width: '60%'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _createTextVNode(" 共 " + _toDisplayString(_unref(selectedConv).count) + " 条与 \"" + _toDisplayString(_unref(searchTarget)) + "\" 相关的聊天记录 ", 1),
              _createVNode(TgMsgWindow, {
                class: "TgMsgWindowDialog",
                isGetMsgByTarget: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (searchDialogForChatRoom.value)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          ref: "SearchDialogForChatRoom",
          modelValue: searchDialogForChatRoom.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchDialogForChatRoom).value = $event)),
          title: "查找聊天记录",
          width: '60%'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createTextVNode(" \"" + _toDisplayString(_unref(selectedConv).Participants.Name + (_unref(selectedConv).Participants.Username === '' ? '' : '(' +
                _unref(selectedConv).Participants.Username + ')')) + "\"在 \"" + _toDisplayString(_unref(selectedConv).Title) + "\" 中发送的信息 ", 1),
              _createVNode(TgMsgWindow, {
                class: "TgMsgWindowDialog",
                isGetMsgByTarget: 2
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})